export default "__VITE_ASSET__6909171f__"